import styled from '@emotion/styled'

export const UserActionsContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`

export const ToggleContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

export const RadioContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

export const ResendLink = styled.div`
  cursor: pointer;
  color: blue;
  text-decoration: underline;
`
